module.exports = __webpack_public_path__ + "static/img/2025-07-5.d8a3aafc.png";